// Module
var code = `<div class = 'capabilities-heading'>

   <div class="heading-item heading-item-text">
       <p class="capabilities-eyebrow-text">{{eyebrow}}</p>

       <p class="capabilities-headline-text">{{headline}}</p>
    <p class="capabilities-subhead-text">{{subhead}}</p>
   </div>
    <div class="heading-item heading-item-img">
        <img src="imgs/design-header.png" alt="design-header" />

    </div>

</div>


<!--
    <div class="configurator-capabilities">
        <h2>Core Capabilities</h2>

        <ul>
            {{#capabilities}}
            <li>
                <h4 class="title">{{title}}</h4>
                <p>{{body}}</p>
            </li>
            {{/capabilities}}

        </ul>



    </div>
-->

`;
// Exports
module.exports = code;